module.exports = __webpack_public_path__ + "static/1-d9ca21daaaf65f6bbdb81e8e5335ae53.jpg";